import { useKeyAndSecretPanel } from './useKeyAndSecretPanel';
import { CLIENT } from './KeyAndSecretPanelUtil';
import * as React from 'react';

export const KeyAndSecretPanel = () => {
  const { copyToClipBoard, onClose, secrets, activeButton, isRlb } = useKeyAndSecretPanel();

  return (
    <div>
      <span className="text-danger mt-2 fs-5">
        { isRlb ? "Az RLB programba kérjük másold át a lenti két kulcsot!":
          "Kérjük mentse az adatokat biztonságos helyre,  mert az Access Key Secret -et csak egyszer és csak most jelenítjük meg,később nem tudja módosítani, csak újat generálni!"}
      </span>

      <div className="mt-4">
        <div className="pb-2">
          <label className="mb-1" htmlFor={'clientId'}>
            Access Key Id
          </label>

          <div className="input-group mb-3">
            <input
              type="text"
              className="form-control"
              defaultValue={secrets?.clientId}
              readOnly={true}
              id="clientId"
            />
            <button
              onClick={() => copyToClipBoard(CLIENT.ID)}
              data-testid="copyClientIdToClipBoardBtn"
              className={activeButton === CLIENT.ID ? 'btn btn-outline-danger' : 'btn btn-outline-secondary'}
              type="button"
            >
              {activeButton === CLIENT.ID ? 'Vágólapra másolva' : 'Másolás'}
            </button>
          </div>
        </div>
        <div className="pb-2">
          <label className="mb-1" htmlFor={'clientSecret'}>
            Access Key Secret
          </label>

          <div className="input-group mb-3">
            <input
              type="text"
              className="form-control"
              defaultValue={secrets?.clientSecret}
              readOnly={true}
              id="clientSecret"
            />
            <button
              onClick={() => copyToClipBoard(CLIENT.SECRET)}
              className={activeButton === CLIENT.SECRET ? 'btn btn-outline-danger' : 'btn btn-outline-secondary'}
              type="button"
              data-testid="copyClientSecretToClipBoardBtn"
            >
              {activeButton === CLIENT.SECRET ? 'Vágólapra másolva' : 'Másolás'}
            </button>
          </div>
        </div>
      </div>
      <div className="modal-footer">
        <button onClick={onClose} className="btn btn-primary">
          Bezár
        </button>
      </div>
    </div>
  );
};
